import { AuthenticationType } from "./authentication-type";
import { Person } from "./person";
import { Status } from "./status";

export class User {
  id: number = 0;
  username: string = "";
  password?: string = "";
  email: string = "";
  name?: string = "";
  surname?: string = "";
  fullname: string = "";
  person: Person = new Person();
  authenticationType: AuthenticationType = new AuthenticationType();
  status: Status = new Status();
  createdAt?: Date = new Date();
  verificationCode?: string | null = null;
  entraReferenceId?: string | null = null;
  updatedAt?: Date;
  avatar?: string = "";
  roles?: string[] = [];
  captcha?: string;
  superUser?: boolean;
}

export class UserOption {
  surname: string;
  name: string;
  id: number;
  username: string;
  email: string;
  fullname: string | null;
}
